import React, { Component } from 'react'
import { withRouter } from '../extensions/withRouter.js';
import InfoBox from '../components/InfoBox.js';
import TitleBar from '../components/TitleBar.js';
import PageBody from '../components/PageBody.js';
import IconButton from '@mui/material/IconButton';
import BarcodeScanner from '../components/BarcodeScanner.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightToBracket, faCircleUser, faVideo, faMicrochip, faLeftLong } from '@fortawesome/free-solid-svg-icons';
import PageFooter from '../components/PageFooter.js';
import ScannedCode from '../components/ScannedCode.js';
import LocalPersistency from '../services/LocalPersistency.js';

/**
 * Read MCR code component
 */
class ReadMCRPage extends Component {

    constructor(props) {
        super(props);

        const storedMcrId = LocalPersistency.getMcrId();

        // component state init
        this.state = {
            scannedCode: storedMcrId,
            confirmDisabled: storedMcrId === null || storedMcrId === undefined || storedMcrId === ''
        };

        this.handleScan = this.handleScan.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleAcceptMcrIdClick = this.handleAcceptMcrIdClick.bind(this);
        this.scannerRef = React.createRef();
    }

    // "cancel" callback - returns to photo documentation page
    handleCancel() {
        this.scannerRef.current.handleTerminate();
        this.props.navigate('/photo-new', { replace: true });
    }

    // barcode scan callback
    handleScan(result, format) {

        if (format !== "qr") {
            return;
        }

        // do not consider user QR codes
        if (!result.startsWith("MCR:") && !result.startsWith("mcr:")) {
            return;
        }

        var mcrId = result.substring(4).trim();
        
        this.setState({
            scannedCode: mcrId,
            confirmDisabled: false
        });
    }
    
    // when the device code is accepted, move to photodocumentation state
    handleAcceptMcrIdClick() {
        this.scannerRef.current.handleTerminate();
        LocalPersistency.setMcrId(this.state.scannedCode);
        this.props.navigate('/control-mcr');
    }

    render() {

        // user identity is stored in session
        const userData = LocalPersistency.getUserIdentity();
        const storedDeviceId = LocalPersistency.getDeviceId();

        // in case we got here by an accident, navigate back to the index page
        if (typeof userData === 'undefined' || userData === null || typeof storedDeviceId === 'undefined' || storedDeviceId === null) {
            setTimeout(() => {
                this.props.navigate('/', { replace: true });
            }, 1000);

            return (<></>);
        }

        return (
            <div className="app">
                <TitleBar>Identifikace místa</TitleBar>
                <InfoBox>
                    <table>
                        <tbody>
                            <tr>
                                <th><FontAwesomeIcon icon={faCircleUser} /></th>
                                <td>{userData.name} {userData.surname}</td>
                            </tr>
                            <tr>
                                <th><FontAwesomeIcon icon={faMicrochip} /></th>
                                <td>{storedDeviceId}</td>
                            </tr>
                        </tbody>
                    </table>
                    <hr />
                    Načtěte QR kód kontrolního místa.<br />
                    Níže pak potvrďte správnost informací.
                </InfoBox>
                <PageBody>
                    <div className="full-width">
                        <BarcodeScanner ref={this.scannerRef} onDecode={this.handleScan}></BarcodeScanner>
                    </div>
                    <ScannedCode code={this.state.scannedCode} iconRef={faVideo} />
                </PageBody>
                <PageFooter>
                    <IconButton onClick={this.handleCancel}>
                        <FontAwesomeIcon size="1x" icon={faLeftLong} />
                    </IconButton>
                    <IconButton disabled={this.state.confirmDisabled} onClick={this.handleAcceptMcrIdClick}>
                        <FontAwesomeIcon size="1x" icon={faRightToBracket} />
                    </IconButton>
                </PageFooter>
            </div>
        );
    }
}

export default withRouter(ReadMCRPage);
